module.exports = __webpack_public_path__ + "static/media/021.8b3746d4.jpg";